import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import swal from 'sweetalert';

import CasinoCRMApi from '../../../../casino/Api/CRM/CasinoCRMApi';
import CasinoGameCategory from '../../../../casino/Api/Models/CasinoGameCategory';

import { CASINO_GAME_CATEGORY } from '../Helpers/CrmUrls';

import GameCategoryForm, { GameCategoryTranslationsError } from './GameCategoryForm';

interface GameCategoryEditParams {
    id: string;
}

function GameCategoryEdit() {
    const [errors, setErrors] = useState<string[]>([]);
    const [translationErrors, setTranslationsErrors] = useState<GameCategoryTranslationsError[]>([]);
    const history = useHistory();
    const { id } = useParams<GameCategoryEditParams>();

    const handleSubmit = (gameCategory: CasinoGameCategory, onFinish: () => void) => {
        CasinoCRMApi.gameCategories
            .update(Number.parseInt(id), gameCategory)
            .then(() => {
                history.push({
                    pathname: CASINO_GAME_CATEGORY,
                });
            })
            .catch((error) => {
                if (!error.response) {
                    setErrors([error.message]);
                } else if (error.response.status !== 500 && error.response.data?.errors !== undefined) {
                    if (
                        error.response.data.errors.casino_game_category_translations &&
                        error.response.data.errors.casino_game_category_translations[0]?.hasOwnProperty('language_id')
                    ) {
                        setTranslationsErrors(error.response.data.errors.casino_game_category_translations);
                    } else {
                        setTranslationsErrors([]);
                    }
                    error.response.data.errors.casino_game_category_translations = undefined;

                    setErrors(error.response.data.errors);
                } else {
                    swal({
                        title: 'Error',
                        text: 'Server error',
                        icon: 'error',
                    });
                }
            })
            .finally(() => {
                onFinish();
            });
    };

    return (
        <GameCategoryForm
            gameCategoryId={parseInt(id)}
            handleSubmit={handleSubmit}
            errors={errors}
            translationErrors={translationErrors}
        />
    );
}

export default GameCategoryEdit;
